import React from 'react';

import logo from '../_images/logo.png';


export const NAV = {
    h2s: [{
        h3s: [{
            title: 'C.V.',
            url: '/cv'
        }],
        images: [{
            alt: '',
            id: 'homepageLogo',
            src: logo
        }],
        title: 'Home',
        url: '/'
    }],
    id: 'siteNav'
};

export function Breadcrumbs ({rawBreadcrumbs, isCurrent, rel}) {
    var breadcrumb = null,
        breadcrumbs = [],
        classNames = [];

    if (isCurrent) {
        classNames.push('current');

        if (rel === 'index') {
            classNames.push('hidden');
        }
    }

    for (let index = 0; index < rawBreadcrumbs.length; index++) {
        breadcrumb = rawBreadcrumbs[index];
        breadcrumbs.push(<li key={index + 1} className={classNames.join(' ')} itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <meta itemProp="position" content={index + 1}/>
            <a href={breadcrumb.href} rel={breadcrumb.rel} title={breadcrumb.title} itemProp="item">
                <span itemProp="name">{breadcrumb.title}</span>
            </a>
        </li>);
    }

    if (!!breadcrumbs) {
        return <ol id="breadcrumbs" itemScope itemType="https://schema.org/BreadcrumbList">
            {breadcrumbs}
        </ol>
    };
}

export function Copyright () {
    return <p id="copyright">
        © C. A. Hutton
    </p>;
}

export function Footer ({breadcrumbs}) {
    return <footer>
        {breadcrumbs &&
            <Breadcrumbs rawBreadcrumbs={breadcrumbs}/>
        }
        <Copyright/>
    </footer>;
}

export function Header ({nav, current}) {
    return <header>
        {!!nav ?
            <Nav nav={nav} innerNav={<Nav nav={NAV}/>} current={current}/>
        :
            <Nav nav={NAV} current={current}/>
        }
    </header>;
}

export function Nav ({nav, current, innerNav}) {
    function getNav(subnavArray, currentHref) {
        return subnavArray.h2s.reduce((h2Accumulator, h2CurrentValue, h2CurrentIndex) => {
            h2Accumulator.push(<div key={h2CurrentIndex}>
                <a href={h2CurrentValue.url} title={h2CurrentValue.title}>
                    {h2CurrentValue.images &&
                        h2CurrentValue.images.reduce((h2ImgAccumulator, h2ImgCurrentValue) => {
                            h2ImgAccumulator.push(<img key={h2ImgCurrentValue.id} id={h2ImgCurrentValue.id} src={h2ImgCurrentValue.src} alt={h2ImgCurrentValue.alt}/>);

                            return h2ImgAccumulator;
                        }, [])
                    }
                    <h2>{h2CurrentValue.title}</h2>
                </a>
                {h2CurrentValue.h3s &&
                    <ol>
                        {h2CurrentValue.h3s.reduce((h3Accumulator, h3CurrentValue, h3CurrentIndex) => {
                            h3Accumulator.push(<li key={h3CurrentIndex} className={h3CurrentValue.url === currentHref ? 'current' : null}>
                                {h3CurrentValue.url === currentHref ?
                                    <h3>{h3CurrentValue.title}</h3>
                                :
                                    <a href={h3CurrentValue.url} target={h3CurrentValue.target}>
                                        <h3>{h3CurrentValue.title}</h3>
                                    </a>
                                }
                                {h3CurrentValue.h4s &&
                                    <ol>
                                        {h3CurrentValue.h4s.reduce((h4Accumulator, h4CurrentValue, h4CurrentIndex) => {
                                            h4Accumulator.push(<li key={h4CurrentIndex} className={h4CurrentValue.url === currentHref ? 'current' : null}>
                                                <a href={h4CurrentValue.url}>
                                                    <h4>{h4CurrentValue.title}</h4>
                                                </a>
                                            </li>);

                                            return h4Accumulator;
                                        }, [])
                                        }
                                    </ol>
                                }
                            </li>);

                            return h3Accumulator;
                        }, [])
                        }
                    </ol>
                }
            </div>);

            return h2Accumulator;
        }, []);
    }

    return <nav id={nav.id}>
        {getNav(nav, current)}
        {innerNav}
    </nav>;
}

export function PageTitle ({title}) {
    return <h1 id="pageTitle">{title}</h1>;
}
